import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectorRef, ViewChild } from '@angular/core';
import utf8 from 'utf8';
import { PacientService } from 'src/services/pacient.service';
import { Organization } from 'src/models/organization.model';
import { Practicioner } from 'src/models/practicioner.model';
import { IonInfiniteScroll, LoadingController } from '@ionic/angular';
import * as moment from 'moment';

@Component({
    selector: 'time-line-component',
    templateUrl: 'time-line-component.html',
    styleUrls: ['./time-line-component.scss']
})

export class TimeLineComponent implements OnInit {

    @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
    // @Input() classCSS: string;

    @Input() historico: any = {};
    @Input() searchQuery: any = {};
    @Input() nextUrl: any;
    @Input() user: any;

    @Output() onDetalheAtendinento = new EventEmitter();
    @Output() onLoadData = new EventEmitter();
    listAtendimento: any = [];
    listInternacao: any = [];
    filtradoAtendimento: boolean = false;
    filtradoAtencao: boolean = false;

    constructor(private pacient: PacientService,
        private loadingCtrl: LoadingController,
        private cd: ChangeDetectorRef) {
    }

    ngOnInit() {
        console.log('ngOnInit -> MedicamentosComponent', this.historico);
        this.listAtendimento = this.historico.filter((item) => {
            return (item.categoria.toUpperCase() === 'AMBULATORIAL ESPECIALIZADA');
        });

        this.listInternacao = this.historico.filter((item) => {
            return (item.categoria.toUpperCase() === 'ATENÇÃO HOSPITALAR');
        });

        this.historico = this.historico.filter((item) => {
            return (item.categoria.toUpperCase() === 'ATENÇÃO HOSPITALAR');
        });
    }

    async set() {
        let loading = await this.loadingCtrl.create({});
        await loading.present();

        this.historico = await (await this.pacient.getHistory(this.user)).docs;
        
        await loading.dismiss();
    }
    
    detalheAtendinento(item) {
        this.onDetalheAtendinento.emit({
            atendimento: item
        });
    }

    async loadData(event) {
        if (this.nextUrl) {
            setTimeout(async () => {
                let history = await this.pacient.getHistory(this.user, this.nextUrl);
                this.historico = this.historico.itens.concat(history.docs);

                this.listAtendimento = this.historico.filter((item) => {
                    return (item.categoria.toUpperCase() === 'AMBULATORIAL ESPECIALIZADA');
                });
                this.listInternacao = this.historico.filter((item) => {
                    return (item.categoria.toUpperCase() === 'ATENÇÃO HOSPITALAR');
                });
                event.target.complete();
                if (!this.nextUrl) {
                    event.target.disabled = true;
                }
            }, 500);
        } else {
            event.target.disabled = true;
        }
    }

    getIconTipo(tipo) {

        if (tipo.toUpperCase() === 'ATENDIMENTO CLÍNICO') {
            return '/assets/imgs/icons/icon-atendimento.svg';
        } else if (tipo.toUpperCase() === 'RESULTADO DE EXAMES') {
            return '/assets/imgs/icons/icon-exames.png';
        } else if (tipo.toUpperCase() === 'SUMÁRIO DE ALTA') {
            return '/assets/imgs/icons/icon-atendimento.svg';
        } else if (tipo.toUpperCase() === 'REGISTROS DE VACINA') {
            return '/assets/imgs/icons/icon-vacina.png';
        } else if (tipo.toUpperCase() === 'MEDICAMENTOS') {
            return '/assets/imgs/icons/icon-medicamentos_2.png';
        } else if (tipo.toUpperCase() === 'PRESCRICOES') {
            return '/assets/imgs/icons/prescricoes.png';
        }
    }

    getIconCategoria(categoria) {
        if (categoria.toUpperCase() === 'AMBULATORIAL ESPECIALIZADA') {
            return '/assets/imgs/icons/icon-atendimento.svg';
        } else if (categoria.toUpperCase() === 'ATENÇÃO HOSPITALAR') {
            return '/assets/imgs/icons/icon-internacao.png';
        }
    }

    async loadInfoOrg (reference, item) {
        const orgData = await this.pacient.getRead(reference);
        if (orgData) {
            item.organization = new Organization(orgData);
            item.estabelecimento =  item.organization.nome;
        }
    }

    async loadInfoProf (reference, item) {
        const practicionerRole = await this.pacient.getRead(reference);
        if (practicionerRole && practicionerRole.practitioner) {
            const practData = await this.pacient.getRead(practicionerRole.practitioner.reference);
            if (practData) {
                item.practicioner = new Practicioner(practData);
                item.profissional = item.practicioner.nome;
            }
        } 
    }

    decodeUtf(data) {
        let decode = data;
        if (typeof data === 'string') {
            decode = utf8.decode(data);
        }
        return decode;
    }

    getDate(data) {
        return moment(data).format('DD/MM/YYYY');
    }

    async filtrarTipo(tipo) {
        switch (tipo) {
            case 'atendimento':
                await this.set();
                if(this.filtradoAtendimento) {
                    return this.filtradoAtendimento = !this.filtradoAtendimento;;
                }

                this.historico = this.historico.filter((item) => {
                    return (item.categoria.toUpperCase() === 'AMBULATORIAL ESPECIALIZADA');
                });
                this.filtradoAtendimento = !this.filtradoAtendimento;
                this.filtradoAtencao = false;
            break;
            case 'internacao':
                await this.set();
                if(this.filtradoAtencao) {
                    return this.filtradoAtencao = !this.filtradoAtencao;
                }

                this.historico = this.historico.filter((item) => {
                    return (item.categoria.toUpperCase() === 'ATENÇÃO HOSPITALAR');
                });
                this.filtradoAtencao = !this.filtradoAtencao;
                this.filtradoAtendimento = false;
            break;
        }
    }
}
